var render = function render(){var _vm=this,_c=_vm._self._c;return _c('list-default',{ref:"list",attrs:{"resolver":_vm.resolver},on:{"updateList":_vm.updateList}})
}
var staticRenderFns = []

export { render, staticRenderFns }